import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Text } from 'mintel-react-ui';

import ArticleBlock from '/components/ArticleBlock';
import { BlockProps, Present } from '/types';
import { BlockBackgroundContext, PresentModeContext } from '/utils/contexts';
import { contentFilter } from '/utils/functions';

import styles from './BlockSectionHeader.scss';
import { DangerousH2 } from '../common';

const BlockSectionHeader: VFC<BlockProps> = (props) => {
  const presentMode = useContext(PresentModeContext);
  const { darkBg } = useContext(BlockBackgroundContext);
  const titleJson = props?.blockContent?.title;
  const textJson = props?.blockContent?.text;
  const text = contentFilter(textJson, presentMode, props.presentOption);

  return (
    <ArticleBlock {...props} noTitle>
      <div
        className={classNames(
          props?.sub ? styles['sub-header'] : styles.header,
          {
            [styles.keynote]: presentMode === Present.Keynote,
            [styles['present-mode']]: !!presentMode,
          },
        )}
      >
        {!titleJson?.hidden && titleJson?.content && (
          <Text.Heading2 darkBg={darkBg}>
            <DangerousH2 className={styles.title}>
              {titleJson?.content}
            </DangerousH2>
          </Text.Heading2>
        )}
        {!textJson?.hidden && text && (
          <Text.Body darkBg={darkBg}>
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </Text.Body>
        )}
      </div>
    </ArticleBlock>
  );
};

BlockSectionHeader.displayName = 'BlockSectionHeader';
export default BlockSectionHeader;
